<app-navbar title="Lista zadań"></app-navbar>
<mat-expansion-panel [expanded]="true" class="mb-3">
	<mat-expansion-panel-header>
		<mat-panel-title
			><mat-panel-title
				><i class="fa fa-filter"></i><span class="ms-2 font-weight-600">Filtry</span></mat-panel-title
			></mat-panel-title
		>
	</mat-expansion-panel-header>
	<app-general-tasks-filter></app-general-tasks-filter>
</mat-expansion-panel>
<app-tasks-list
	view="tab"
	type="general"
	(setFilters)="setFilters()"
	[tableId]="''"
	[tableName]="TableName.USER_PROFILE"
></app-tasks-list>
